import { Modal } from 'antd';
import React from 'react';
import { useForm } from 'react-hook-form';
import FormInput from 'components/Common/FormInput';
import AntButton from 'components/Common/AntButton';
import { ChargeWalletUrl } from 'services/routes';
import request from 'services/request';
import fa from 'locales/fa.json';
import { useRouter } from 'next/router';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChargeWallet: React.FC<any> = ({ open, setOpen, body }) => {
  const { handleSubmit, formState, control } = useForm();
  const router = useRouter();

  const onSubmit = async ({ value }): Promise<void> => {
    const res: any = await request.post(ChargeWalletUrl(value)); // eslint-disable-line
    if (res.ok) {
      localStorage.setItem(
        'payment',
        JSON.stringify({ type: 'advisor', url: router.asPath, ...body }),
      );
      await window.location.assign(res.data.link);
      setOpen(false);
    }
  };

  return (
    <Modal
      title={null}
      footer={null}
      destroyOnClose
      open={open}
      onCancel={(): void => setOpen(false)}
    >
      <form className="" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-[28px] text-center font-bold text-[20px]">افزایش اعتبار</div>
        <FormInput
          control={control}
          name="value"
          className="mb-16 w-full"
          autoComplete="off"
          rules={{
            required: true,
            pattern: {
              value: /^[\u06F0-\u06F90-9]+$/,
              message: fa.account.justDigit,
            },
          }}
          title="مبلغ (تومان)"
        />

        <AntButton
          htmlType="submit"
          className="w-full mb-8"
          loading={formState.isSubmitting}
        >
          پرداخت
        </AntButton>
      </form>
    </Modal>
  );
};

export default ChargeWallet;
